import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export default function Guarantee() {
  return (
    <section
      data-testid="guarantee-section"
      className="bg-[#F4EBDE] py-20 md:py-24"
    >
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="relative bg-white rounded-[2.5rem] p-10 md:p-14 border border-[#E8DDC9] shadow-[0_20px_60px_rgba(78,60,40,0.08)] text-center"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#849983]/12 mx-auto mb-6">
            <ShieldCheck className="h-7 w-7 text-[#849983]" strokeWidth={1.6} />
          </div>
          <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
            Compra sin riesgo
          </p>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl tracking-tight leading-tight text-[#2A302A]">
            Garantía de <em className="italic">satisfacción</em>.
          </h2>
          <p className="mt-6 text-base md:text-[17px] leading-relaxed text-[#576057] max-w-xl mx-auto">
            Si el ebook no te ayuda a organizar las comidas de tu familia, escríbenos
            dentro de <strong className="text-[#2A302A]">7 días</strong> y te
            devolvemos tu dinero.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
